// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"231":"comparison","535":"login","729":"dataReport","900":"dataReports","919":"indexView"}[chunkId] + "." + {"231":"a2a5629c","535":"0463a536","729":"9765e0fa","900":"62c5f4e1","919":"bd653efc"}[chunkId] + ".js";
};